export default __webpack_public_path__ + "static/media/icon-metronome.b7f7a33a.svg";